export const QAPartType = {
  textarea: "textarea",
  text: "text",
  boolean: "boolean",
  number: "number",
  year: "year",
  percentage: "percentage",
  metric: "metric",
  select: "select",
  table: "table",
  date: "date",
  /** fixed text eg a row label */
  fixed: "fixed",
  /** for attachments */
  file: "file",
};

/**
 * JSON format for question.parts  answer
 * See json_schema.py
 */
export default class QAPart {
  /** @type {string} Question text */
  questionPart;
  /** @type {string} Type of question part - see QAPartType */
  type;
  /** @type {string[]|Object[]} Options for select */
  options;
  /** @type {string} weight | money */
  metricType;
  /** @type {string} kg | GBP */
  unit;
  /** @type {string} e.g. "answer('a') == 'yes'" */
  condition;
  /** @type {string?} The user answer. For type=table, this is a csv string for QAPart[][] */
  answerValue;
  /** @type {QAPart[]} Columns for table */
  columns;
  /** @type {csv|string[]} Rows for table */
  rows;
  /** @type {boolean} If type=rows, Should be: isFixedRow == !!rows */
  isFixedRow;
  /** @type {boolean} If true, the answer will be auto-calculated by CDP from other answers */
  autoCalculated;
  /** @type {string} The formula for the auto-calculated answer - for reference only, we do not apply this*/
  autoCalculatedFormula;
}
